import BillEntries from 'main/content/accounting/billEntries/BillEntries';

export const BillEntriesConfig = {
    settings: {
        layout: {}
    },
    auth : ['admin','supervisor'],
    routes  : [
        {
            path     : '/account/billEntries',
            component: BillEntries
        }
    ]
};


// WEBPACK FOOTER //
// ./src/main/content/accounting/billEntries/BillEntriesConfig.js